import { components } from 'knockout';

import { DetailsModalViewModel } from "./details-modal";
import DetailsModalTemplate from "./details-modal.html?raw";
import TabArtistTemplate from "./tabs/artist.html?raw";
import TabHostTemplate from "./tabs/host.html?raw";
import TabEventsTemplate from "./tabs/events.html?raw";
import TabHistoryTemplate from "./tabs/history.html?raw";
import TabChatTemplate from "./tabs/chat.html?raw";
import TabCallTemplate from "./tabs/call.html?raw";
import TabMailTemplate from "./tabs/mail.html?raw";

if (!components.isRegistered("details-modal")) {
    console.log('hey register details-modal now')
    // Register the partial tab templates
    components.register('tab-artist', {
        template: TabArtistTemplate
    });
    components.register('tab-host', {
        template: TabHostTemplate
    });
    components.register('tab-events', {
        template: TabEventsTemplate
    });
    components.register('tab-history', {
        template: TabHistoryTemplate
    });
    components.register('tab-chat', {
        template: TabChatTemplate
    });
    components.register('tab-call', {
        template: TabCallTemplate
    });
    components.register('tab-mail', {
        template: TabMailTemplate
    });

    // Main component
    components.register('details-modal', {
        viewModel: {
            createViewModel: function (params, componentInfo) {
                var vm = new DetailsModalViewModel(params);
                window.details_modal_vm = vm;
                return vm;
            },
        },
        template: DetailsModalTemplate
    });
}
